<template>
  <BreadCrumb PageTitle="Avatars" />
  <AvatarsContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import AvatarsContent from "../../template-components/UIElements/Avatars/AvatarsContent.vue";

export default defineComponent({
  name: "AvatarsPage",
  components: {
    BreadCrumb,
    AvatarsContent,
  },
});
</script>